import { normalizeIngredientName } from '../ingredients/normalize-name.js';
/**
 * Suggestions while typing (docs/partial/shopping-list-extensions-spec.md 6.4): what this household
 * buys, prefix matches before substring matches, frequent and recent purchases first
 * (use count with a half-life of 60 days). The same function ranks on the server and – from
 * the device copy of the history – offline.
 */
export const SUGGESTION_HALF_LIFE_DAYS = 60;
export function suggestionScore(entry, now) {
    const ageDays = Math.max(0, (now - Date.parse(entry.lastUsedAt)) / 86_400_000);
    return entry.useCount * Math.pow(0.5, ageDays / SUGGESTION_HALF_LIFE_DAYS);
}
export function rankSuggestions(entries, query, context) {
    const now = context.now ?? Date.now();
    const open = new Set(context.openNames);
    const bought = new Set(context.boughtNames);
    const needle = normalizeIngredientName(query) || query.trim().toLowerCase();
    const ranked = [];
    for (const entry of entries) {
        if (entry.hidden || open.has(entry.normalizedName))
            continue;
        let group = 0;
        if (needle) {
            const haystack = entry.normalizedName;
            const display = entry.displayName.toLowerCase();
            if (haystack.startsWith(needle) || display.startsWith(needle))
                group = 0;
            else if (haystack.split(' ').some((word) => word.startsWith(needle)))
                group = 1;
            else if (haystack.includes(needle) || display.includes(needle))
                group = 2;
            else
                continue;
        }
        const reactivates = bought.has(entry.normalizedName);
        ranked.push({
            entry,
            // What sits in "Bought" on this very list is the most likely thing to come back.
            score: suggestionScore(entry, now) * (reactivates ? 1.5 : 1),
            reactivates,
            group,
        });
    }
    return ranked
        .sort((a, b) => a.group - b.group ||
        b.score - a.score ||
        a.entry.displayName.localeCompare(b.entry.displayName))
        .slice(0, context.limit ?? 8)
        .map(({ group: _group, ...rest }) => rest);
}
//# sourceMappingURL=suggestions.js.map